
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import Loading from './Loading';
import { featchSearchActivity } from '../features/Activity/SearchActivity';
import { CalenderIcon, ReadMoreIcon } from "./Header/Icon";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
import NoResultsPage from './NoResultsPage';

function SearchPage() {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const q = searchParams.get('q') || '';  
    const [perPage, setPerPage] = useState(20000);
    const { activities, loading, total } = useSelector((state) => state.featchSearchActivity || { activities: [], loading: false });
    useEffect(() => {
        dispatch(featchSearchActivity({ perPage: perPage, search: q }));
    }, [dispatch, i18n.language,q]);

    const handleScroll = useCallback(() => {
        if (
            window.innerHeight + document.documentElement.scrollTop + 124 >=
            document.documentElement.offsetHeight &&
            activities?.length >= perPage
        ) {
            setPerPage((prev) => prev + 6);
        }
    }, [activities?.length, perPage]);

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [handleScroll]);
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                when: "beforeChildren"
            }
        }
    };

    const cardVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.4 }
        },
        hover: {
            y: -5,
            scale: 1.02,
            transition: { type: "spring", stiffness: 300 }
        }
    };

    const imageVariants = {
        hover: {
            scale: 1.1,
            transition: { duration: 0.3 }
        }
    };

    if (loading) return <Loading />;
    if (total == 0 || activities?.length == 0) return <NoResultsPage/>

    return (
        <div className="mx-auto my-3 mt-10 w-11/12 md:w-10/12 2xl:w-9/12">


            <motion.div
                variants={containerVariants}
                initial="hidden"
                animate="visible"
                className="grid grid-cols-1 w-full gap-8 py-6 md:grid-cols-2 lg:grid-cols-3"
            >
                <AnimatePresence>
                    {activities?.map((activity) => (
                        
                        <motion.div
                            key={activity.id}
                            variants={cardVariants}
                        >
                            <Link to={`/${activity?.type}/${activity.id}`}>
                                <motion.div
                                    whileTap={{ scale: 0.98 }}
                                    className="bg-white w-full overflow-hidden h-[370px] rounded-md shadow-md transition-transform duration-500 flex flex-col hover:shadow-lg"
                                >
                                    <motion.div
                                        className="relative w-full  h-[200px] overflow-hidden rounded-t-md"
                                        variants={imageVariants}
                                    >
                                        <motion.img
                                            src={process.env.REACT_APP_IMG_URL + activity.image  }
                                            alt="activity"
                                            className="w-full h-full object-cover"

                                            transition={{ duration: 0.4 }}
                                        />

                                        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>

                                        <div className="absolute top-4 right-4 bg-green-700 px-3 py-1.5 rounded-lg shadow text-gray-100 flex items-center gap-2 text-sm">
                                            <CalenderIcon className="w-4 h-4 text-white" />
                                            <span>
                                                {new Date(activity.published_at).toLocaleDateString("en-US", {
                                                    month: "short",
                                                    day: "numeric",
                                                    year: "numeric",
                                                })}
                                            </span>
                                        </div>
                                    </motion.div>

                                    {/* Content Section */}
                                    <div className="flex flex-col justify-between flex-1 p-4">
                                        <div>
                                            <h2 className="text-xl font-bold text-gray-900 leading-tight">
                                                <span className="bg-gradient-to-r from-emerald-400/30 to-cyan-400/30 bg-[length:0%_3px] bg-left-bottom bg-no-repeat transition-[background-size] duration-300 hover:bg-[length:100%_3px]">
                                                    {activity.title[i18n.language] || activity.title.en}
                                                </span>
                                            </h2>

                                            <p
                                                className="text-gray-600 text-sm mt-2 line-clamp-3 opacity-90"
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        activity.description[i18n.language].length > 60
                                                            ? activity.description[i18n.language].substring(0, 60) + "..."
                                                            : activity.description[i18n.language],
                                                }}
                                            />
                                        </div>

                                        <div className="border-t border-gray-200 pt-2 mt-3">
                                            <div className="inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-700 font-semibold">
                                                <span>{t("readMore")}</span>
                                                <div className={i18n.language === "ar" || i18n.language === "ckb" ? "rotate-180" : ""}>
                                                    <ReadMoreIcon />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </motion.div>
                            </Link>
                        </motion.div>
                    ))}
                </AnimatePresence>
            </motion.div>

            {loading && <Loading />}
        </div>
    );
}

export default SearchPage;
